'use client';

import { useDisclosure } from '@mantine/hooks';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';

import { ArticlesBlock } from '../ArticlesBlock';
import { Header } from './Header';
import { Main } from './Main';
import { MobileMenu } from './MobileMenu';
import { Sidebar } from './Sidebar';
import styles from './Layout.module.css';

export const Layout = ({ children }: PropsWithChildren) => {
  const [isOpen, handlers] = useDisclosure();

  return (
    <div className={styles.layout} data-shifted={isOpen}>
      <div className={styles.page}>
        <Header toggleMenu={handlers.toggle} isMenuOpen={isOpen} />
        <div className={styles.container}>
          <div className={clsx(styles.sidebar, 'scroll')}>
            <Sidebar />
          </div>

          <Main>{children}</Main>

          <div className={styles.topics}>
            <ArticlesBlock />
          </div>
        </div>
      </div>
      <MobileMenu
        className={styles.mobileMenu}
        isOpen={isOpen}
        onClose={handlers.close}
        data-open={isOpen}
      />
    </div>
  );
};
